/**
 * Mock venue data for testing and development
 */
export const mockVenues = [
  {
    name: '主诊室',
    description: '主要看诊和针灸室，设备齐全，环境舒适',
    type: '诊室',
    capacity: 2,
    location: '一楼东侧',
    facilities: ['针灸床', '中药柜', '诊疗设备', '空调'],
    isActive: true
  },
  {
    name: '调理室',
    description: '推拿和艾灸专用室，配备专业按摩床和艾灸设备',
    type: '诊室',
    capacity: 3,
    location: '一楼西侧',
    facilities: ['按摩床', '艾灸设备', '音响系统', '香薰机'],
    isActive: true
  },
  {
    name: '休息室',
    description: '患者休息和等候区，提供舒适的等候环境',
    type: '休息区',
    capacity: 10,
    location: '一楼中厅',
    facilities: ['沙发', '茶水台', '杂志架', '电视', 'WiFi'],
    isActive: true
  },
  {
    name: '中药房',
    description: '中药配制和煎煮室，配备现代化煎药设备',
    type: '药房',
    capacity: 2,
    location: '一楼南侧',
    facilities: ['煎药机', '中药柜', '称量设备', '包装设备'],
    isActive: true
  },
  {
    name: '理疗室',
    description: '专业理疗室，配备各种现代理疗设备',
    type: '诊室',
    capacity: 4,
    location: '二楼东侧',
    facilities: ['理疗床', '红外线设备', '超声波设备', '电疗仪'],
    isActive: true
  },
  {
    name: '妇科诊室',
    description: '专门的妇科诊疗室，隐私性好，设备专业',
    type: '诊室',
    capacity: 1,
    location: '二楼西侧',
    facilities: ['妇科检查床', '私密性屏风', '专用设备', '消毒设备'],
    isActive: true
  },
  {
    name: '儿科诊室',
    description: '儿童专用诊室，环境温馨，适合儿童治疗',
    type: '诊室',
    capacity: 2,
    location: '二楼中厅',
    facilities: ['儿童床', '玩具', '卡通装饰', '安全设施'],
    isActive: true
  }
];

export default mockVenues; 